// @ngInject
function printPickingListDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, level) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'printPickingListDialogController as vm',
            templateUrl: 'services/dialogs/printPickingListDialog/printPickingListDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            level: function() {
                return level;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function printPickingListDialogController($uibModalInstance, $window, message, level, $sce, $translate) {
    var vm = this;

    //Properties
    vm.message = $sce.trustAsHtml(message);
    vm.level = level;
    vm.printLanguage = 'se';
    vm.includeStorageLocation = false;
    vm.includeIsPhotographed = false;
    vm.includePrices = false;
    vm.groupings = [];

    //Methods
    vm.closeModal = closeModal;
    vm.setLanguage = setLanguage;

    activate();

    function activate() {
        vm.groupings = [
            { id: 1, description: $translate.instant('article.articlenumber'), code: 'ArticleNumber' }, //'Produktnummer'
            { id: 2, description: $translate.instant('article.itemgroup'), code: 'ItemGroupCode' }, //'Varugrupp'
            { id: 3, description: $translate.instant('article.brand'), code: 'BrandCode' }, //'Varumärke'
            { id: 4, description: $translate.instant('article.maingroup'), code: 'MainGroupCode' }, //'Huvudgrupp'
            { id: 5, description: $translate.instant('article.department'), code: 'DepartmentCode' } //'Avdelning'
        ];
        vm.selectedGrouping = vm.groupings[0];
        readSettingsFromLocalStorage();
    }

    function closeModal(isCompleted) {
        var result = {
            result: isCompleted,
            languageCode: vm.printLanguage,
            grouping: vm.selectedGrouping.code,
            includeStorageLocation: vm.includeStorageLocation,
            includeIsPhotographed: vm.includeIsPhotographed,
            includePrices: vm.includePrices
        };
        saveSettingsToLocalStorage();
        $uibModalInstance.close(result);
    }

    function setLanguage(language) {
        vm.printLanguage = language;
    }

    function readSettingsFromLocalStorage() {
        if ($window.localStorage.printOrderPickingListSettings) {
            if (!isJsonString($window.localStorage.getItem('printOrderPickingListSettings'))) {
                $window.localStorage.removeItem('printOrderPickingListSettings');
            }

            var settingsStr = $window.localStorage.getItem('printOrderPickingListSettings');
            if (settingsStr !== null) {
                var json = JSON.parse(settingsStr);
                if (json.printLanguage) { vm.printLanguage = json.printLanguage; }
                if (json.includeStorageLocation) { vm.includeStorageLocation = json.includeStorageLocation; }
                if (json.includeIsPhotographed) { vm.includeIsPhotographed = json.includeIsPhotographed; }
                if (json.includePrices) { vm.includePrices = json.includePrices; }
                if (json.grouping && _.indexOf(vm.groupings, function(so) { return so.code === json.grouping; })) { vm.selectedGrouping = _.find(vm.groupings, function(so) { return so.code === json.grouping; }); }
            }
        }
    }
    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function saveSettingsToLocalStorage() {
        var request = {
            printLanguage: angular.copy(vm.printLanguage),
            grouping: angular.copy(vm.selectedGrouping.code),
            includeStorageLocation: vm.includeStorageLocation ? angular.copy(vm.includeStorageLocation) : null,
            includeIsPhotographed: vm.includeIsPhotographed ? angular.copy(vm.includeIsPhotographed) : null,
            includePrices: vm.includeprices ? angular.copy(vm.includePrices) : null
        };

        $window.localStorage.setItem('printOrderPickingListSettings', JSON.stringify(request));
    }
}

angular
    .module('services.dialogs.printPickingListDialog', [])
    .service('printPickingListDialogService', printPickingListDialogService)
    .controller('printPickingListDialogController', printPickingListDialogController);
